import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

import { PasswordResetToken } from 'app/core/authentication/models';

export class PasswordResetTokenValidate implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordResetTokenValidate;
  public readonly payload: PasswordResetToken;

  constructor({
    userId = undefined,
    resetToken = undefined }: PasswordResetToken) {
    this.payload = new PasswordResetToken(userId, resetToken);
  }
}

export class PasswordResetTokenValid implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordResetTokenValid;

  constructor(public readonly payload: string) { }
}

export class PasswordResetTokenInvalid implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordResetTokenInvalid;

  constructor(public readonly payload: any) { }
}
